export default __webpack_public_path__ + "a697e9c58c83e9bae672a91a89ee54e4.svg";